import angular from 'angular';
import { projections } from '~/components/input-geo/input-geo.controller';
import controller from './geo.controller';
import template from './geo.html';
import GeoComponent from './geo.component';

const geoConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('geo', {
		title:                      'Geo coords',
		template,
		group:                      'advanced',
		children:                   false,
		selectable:                 true,
		settings:                   new GeoComponent(),
		icon:                       'fa fa-map',
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/geo/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller,
		onEdit: /* @ngInject */     (
			/** @type {any} */ $scope,
		) => {
			$scope.projections = projections;

			$scope.toggleSelectionAvailableProjection = (/** @type {any} */ projection) => {
				const index = $scope.component.availableProjections.indexOf(projection.id);

				// Is currently selected
				if (index > -1) {
					$scope.component.availableProjections.splice(index, 1);
				}
				// Is newly selected
				else {
					$scope.component.availableProjections.push(projection.id);
				}
			};
		},
	});
};

export default angular.module('app')
	.config(geoConfig);
